import {
    STORE_TRACKER_ACCOUNTS,
    STORE_TRACKER_ACCOUNT,
    REMOVE_TRACKER_ACCOUNT,
} from '../../constants/businessTracker';

const initialState = {
    accounts: [],
    loaded: false,
};

const upsert = (accounts, account) => {
    const idx = accounts.findIndex((a) => a.accountId === account.accountId);
    if (idx === -1) return [...accounts, account];
    const next = accounts.slice();
    next[idx] = account;
    return next;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_TRACKER_ACCOUNTS:
            return {
                ...state,
                accounts: action.accounts || [],
                loaded: true,
            };
        case STORE_TRACKER_ACCOUNT:
            return {
                ...state,
                accounts: upsert(state.accounts, action.account),
            };
        case REMOVE_TRACKER_ACCOUNT:
            return {
                ...state,
                accounts: state.accounts.filter(
                    (a) => a.accountId !== action.accountId,
                ),
            };
        default:
            return state;
    }
};
